// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__lgNvI","footer":"ModalInfo_footer__2LHts"};